export enum UserRequirementsActionsEnum {
  USER_REQUIREMENTS_INIT_PAGE = 'USER_REQUIREMENTS_INIT_PAGE',
  USER_REQUIREMENTS_RESET_PAGE = 'USER_REQUIREMENTS_RESET_PAGE',
  USER_REQUIREMENTS_GET_TEMPLATE_LIST = 'USER_REQUIREMENTS_GET_TEMPLATE_LIST',
  USER_REQUIREMENTS_SET_TEMPLATE_LIST = 'USER_REQUIREMENTS_SET_TEMPLATE_LIST',
  USER_REQUIREMENTS_GET_TEMPLATE_LIST_NEXT_PAGE = 'USER_REQUIREMENTS_GET_TEMPLATE_LIST_NEXT_PAGE',
  USER_REQUIREMENTS_SET_ACTIVE_TEMPLATE_ID = 'USER_REQUIREMENTS_SET_ACTIVE_TEMPLATE_ID',
  USER_REQUIREMENTS_UPDATE = 'USER_REQUIREMENTS_UPDATE',
  USER_REQUIREMENTS_DELETE = 'USER_REQUIREMENTS_DELETE',
  USER_REQUIREMENTS_CHANGE_DEFAULT = 'USER_REQUIREMENTS_CHANGE_DEFAULT',
  USER_REQUIREMENTS_FORM_SUBMIT = 'USER_REQUIREMENTS_FORM_SUBMIT',
}
